import { render, staticRenderFns } from "./shop-dialog.vue?vue&type=template&id=65e57f9e&scoped=true"
import script from "./shop-dialog.vue?vue&type=script&lang=js"
export * from "./shop-dialog.vue?vue&type=script&lang=js"
import style0 from "./shop-dialog.vue?vue&type=style&index=0&id=65e57f9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e57f9e",
  null
  
)

export default component.exports